const _excluded = ["onResolve", "onReject"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import { InlineCohortsModal } from './index';
import type { CohortResult, InlineCohortsModalProps } from './types';

// Creating a wrapper component that handles the modal promise interaction
const InlineCohortsModalWrapper = (props: InlineCohortsModalProps & InstanceProps<CohortResult>) => {
  const {
      onResolve,
      onReject
    } = props,
    modalProps = _objectWithoutProperties(props, _excluded);
  return <div className='inline-cohorts-modal-wrapper' data-sentry-component="InlineCohortsModalWrapper" data-sentry-source-file="util.tsx">
      <InlineCohortsModal {...modalProps} open onClose={() => {
      onResolve({
        cohortStagedValue: null,
        cohortSavedValue: null
      });
    }} onCommitCohort={details => {
      onResolve({
        cohortStagedValue: details,
        cohortSavedValue: null
      });
    }} onCommitSavedCohort={details => {
      onResolve({
        cohortStagedValue: null,
        cohortSavedValue: details
      });
    }} data-sentry-element="InlineCohortsModal" data-sentry-source-file="util.tsx" />
    </div>;
};

/** Example use: `const {cohortStagedValue, cohortSavedValue} = await promptInlineCohorts(props);` */
export const promptInlineCohorts = create(InlineCohortsModalWrapper);